const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    padding: '16px',
    gap: '16px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  certificatePreview: {
    position: 'relative',
    '&:hover $certificateHoverButton': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      '& $editCertificateButton': {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
  },

  certificateHoverButton: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s ease',
    zIndex: 10,
  },

  editCertificateButton: {
    lineHeight: '18px',
    letterSpacing: '0px',
    textAlign: 'center',
    verticalAlign: 'middle',
    opacity: 0,
    transform: 'scale(0.8)',
    transition: 'all 0.3s ease',
    backgroundColor: '#ffffff',
    border: 'none',
    color: '#002e47',
    padding: '8px 16px',
    borderRadius: '10px',
    fontWeight: 500,
    fontFamily: 'Inter',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      transform: 'scale(1)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    },
  },
  templateButton: {
    display: 'flex',
    gap: '16px',
  },
  customizeText: {
    fontSize: '14px',
    fontWeight: 500,
  },
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 16px',
    color: '#002E47',
    height: '36px',
    gap: 8,
    borderRadius: '8px',
    backgroundColor: 'transparent',
    border: '1px solid rgba(145, 158, 171, 0.32)',
    '&:hover': {
      backgroundColor: '#fff',
      border: '1px solid rgba(145, 158, 171, 0.32)',
      cursor: 'pointer',
    },
  },
  buttonText: {
    fontSize: '14px',
    fontWeight: 400,
    marginBottom: '4px',
  },
  templateArea: {
    backgroundColor: '#000',
    width: '940px',
    height: '660px',
    overflow: 'hidden',
    position: 'relative',
    textAlign: 'center',
    outline: 0,
  },
})

export default styles
